/** Indica qual será a ordenação dos itens deste grupo para oferta */
export enum ProdutoAdicionalOrdenacao {
    /** Ordem de inserção dos itens */
    OrdemInsercao = 1,
    /** Nome do item A-Z */
    NomeItemAZ = 2,
    /** Preço unitário A-Z */
    PrecoUnitarioAZ = 3,
    /** Preço unitário Z-A */
    PrecoUnitarioZA = 4,
}

export enum ProdutoAdicionalStatus {
    Ativo = 1,
    Inativo = 2,
}

/** Tipo do funcionamento do preço para este grupo */
export enum ProdutoAdicionalTipoPreco {
    /** Soma o valor dos itens dos adicionais utilizados */
    Soma = 1,
    /** Subtrai o valor do produto com base nos itens marcados deste grupo */
    Subtrai = 2,
    /** Realiza a média de preço somando os itens deste grupo adicionados */
    Media = 3,
    /** Utiliza o preço do item de maior valor do grupo (Padrão para pizzarias) */
    MaiorValor = 4,
}

/** Tipo de seleção dos itens deste grupo de adicionais */
export enum ProdutoAdicionalTipoSelecao {
    /** Seleciona quantos itens desejar por grupo */
    Multipla = 1,
    /** Seleciona um único item por grupo */
    Unica = 2,
}

export enum ProdutoAdicionalItemStatus {
    Ativo = 1,
    Inativo = 2,
}
